import reverse from './reverseFilter';

const toLoad = [
  reverse
];

export default function (ngModule) {
  toLoad.forEach(fn => fn(ngModule));
}
